var map = {
	"./arrow-down 1.svg": 67014,
	"./arrow-left 1.svg": 30279,
	"./arrow-right 1.svg": 3168,
	"./arrow-sm-down-1.svg": 5926,
	"./arrow-sm-left-1.svg": 93435,
	"./arrow-sm-right-1.svg": 47665,
	"./arrow-sm-up-1.svg": 78729,
	"./arrow-up 1.svg": 53629,
	"./arrow_comic.svg": 91832,
	"./back_arrow.svg": 69163,
	"./bottom-parenthesis.svg": 46370,
	"./btn-pause.svg": 11337,
	"./btn-play-1.svg": 37415,
	"./button-play-2.svg": 93818,
	"./button-previous-2.svg": 81587,
	"./c-info_1.svg": 14269,
	"./c-info_2.svg": 37602,
	"./caret-sm-up 1.svg": 84491,
	"./data-download-1.svg": 51776,
	"./detail.svg": 43874,
	"./down_arrow.svg": 84308,
	"./e-remove-1.svg": 49240,
	"./e-remove-2.svg": 18125,
	"./e-remove-3.svg": 29933,
	"./erase.svg": 23606,
	"./expand 2.svg": 69014,
	"./expand 3.svg": 94341,
	"./filter-svgrepo-com.svg": 76861,
	"./i-add-1.svg": 99918,
	"./i-delete-1.svg": 26896,
	"./left-parenthesis.svg": 91156,
	"./link 1.svg": 65392,
	"./loader.svg": 44582,
	"./menu-8-2.svg": 63939,
	"./multi_logo.svg": 67475,
	"./multi_logo_horizontal.svg": 41620,
	"./multi_logotipo_negativo.svg": 7963,
	"./multi_logotipo_negativo_1.svg": 34250,
	"./placeholder.svg": 59866,
	"./placeholder_multi.svg": 56568,
	"./pointing-right-1.svg": 64946,
	"./public-domain.svg": 55799,
	"./question-mark.svg": 96177,
	"./refresh-11.svg": 2352,
	"./refresh-3.svg": 29716,
	"./refresh-4.svg": 24875,
	"./right-parenthesis.svg": 88700,
	"./sound 4.svg": 52122,
	"./subtitles 1.svg": 56030,
	"./top-parenthesis.svg": 61710,
	"./up_arrow.svg": 6104,
	"./video-gallery-3.svg": 7613,
	"./virgolette.svg": 79928,
	"./volume-mute 2.svg": 70181,
	"./zoom-2.svg": 587,
	"./zoom-in-1.svg": 86421,
	"./zoom-opera.svg": 80574,
	"./zoom-out-1.svg": 49129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;